import * as React from "react";
import { Card, Button } from "react-bootstrap";

interface Props {
  refetch: () => void;
}

export const GridError = (props: Props) => {
  return (
    <Card style={{ width: "18rem", margin: "0 auto" }}>
      <Card.Title style={{ marginTop: 5, textAlign: "center" }}>
        Unable to load Grid
      </Card.Title>
      <Card.Body className="align-items-center d-flex justify-content-center">
        <Button onClick={props.refetch}>Reload Grid</Button>
      </Card.Body>
    </Card>
  );
};
